import React from 'react';
import { createRoot } from 'react-dom/client';
import { webCxLibsConfig } from '@rmc/webcx-web-libs';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { ENV, SERVICE_WORKER_SCOPE } from './config';
import packageJson from '../package.json';

webCxLibsConfig.setConfig({ isDimention: true });

async function mockAPI() {
	const { worker } = await import('./mocks/browser');
	const result = await worker.start({
		serviceWorker: {
			url: `${packageJson.homepage}/mockServiceWorker.js`,
			options: {
				// Narrow down the scope of the pages that the worker can control.
				scope: SERVICE_WORKER_SCOPE,
			},
		},
	});
	return result;
}

export async function indexCommon(
	currentScript: HTMLElement | null | SVGScriptElement
) {
	if (ENV === 'MOCK') {
		await mockAPI();
	}

	const root = createRoot(document.createElement('div'));
	root.render(
		<React.StrictMode>
			<App currentScript={currentScript} />
		</React.StrictMode>
	);

	reportWebVitals();
}
